import api from './api';

export interface PreciosProveedorImportParams {
  codigoProveedor: number;
  nombreHoja: string;
  primeraFilaDatos: number;
  /** Si se omite, el servidor procesa hasta el final de la hoja. */
  ultimaFilaDatos?: number;
  columnaCodigoArticuloProveedor: string;
  columnaCosto: string;
  dryRun: boolean;
  guardarHistorico: boolean;
}

export interface PreciosProveedorImportResult {
  filasLeidas: number;
  costosPorProveedorActualizados: number;
  costosPorProveedorCreadosDesdeStock?: number;
  stockRecalculados: number;
  /** Importación por artículo: filas con precio neto de venta aplicado desde Excel. */
  preciosNetoVentaActualizados?: number;
  preciosMinimoActualizados?: number;
  sinCoincidenciaCostosPorProveedor: number;
  /** Importación por artículo: artículo en Stock sin CodProveedor. */
  filasSinProveedorPrincipal?: number;
  /** Importación por artículo: Stock actualizados por costo Excel sin proveedor (no simulación). */
  stockActualizadosSinProveedorPrincipal?: number;
  filasInvalidas: number;
  dryRun: boolean;
  advertencias: string[];
  sinCoincidenciaDetalle: {
    filaExcel: number;
    codigoArticuloProveedor: string;
    codigoArticulo?: string | null;
  }[];
  erroresFila: string[];
}

function appendFormField(form: FormData, key: string, value: string | number | boolean): void {
  form.append(key, String(value));
}

export async function importarPreciosExcel(
  archivo: File,
  params: PreciosProveedorImportParams
): Promise<PreciosProveedorImportResult> {
  const form = new FormData();
  form.append('archivo', archivo);
  appendFormField(form, 'CodigoProveedor', params.codigoProveedor);
  appendFormField(form, 'NombreHoja', params.nombreHoja);
  appendFormField(form, 'PrimeraFilaDatos', params.primeraFilaDatos);
  if (
    params.ultimaFilaDatos !== undefined &&
    params.ultimaFilaDatos !== null &&
    Number.isFinite(params.ultimaFilaDatos)
  ) {
    appendFormField(form, 'UltimaFilaDatos', params.ultimaFilaDatos);
  }
  appendFormField(form, 'ColumnaCodigoArticuloProveedor', params.columnaCodigoArticuloProveedor.trim());
  appendFormField(form, 'ColumnaCosto', params.columnaCosto.trim());
  appendFormField(form, 'DryRun', params.dryRun);
  appendFormField(form, 'GuardarHistorico', params.guardarHistorico);

  const { data } = await api.post<PreciosProveedorImportResult>(
    '/api/PreciosProveedor/importacion-excel',
    form,
    {
      transformRequest: [(body, headers) => {
        delete headers['Content-Type'];
        return body as FormData;
      }],
    }
  );
  return data;
}
